import { Button, Col, Dropdown, Form, Row, Select, Space, Spin, Switch } from 'antd';
import { debounce, get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { BasicButton, BasicInput, BasicLabel, BasicTable } from '../../../../../assets/common';
import { dropdown_icon, edit_delete } from '../../../../../assets/img';
import { adminApi } from '../../../../../services/admin';
import { pushMessage } from '../../../../../store/alertMessageSlice';
import { MESSAGE_TYPES, NOTIFICATION_TYPE, USER_ACCESS_MESSAGE } from '../../../../../utils/constants';
import { checkIntegerNumber, mapDataDropdownOptions } from '../../../../../utils/helper';
import { history } from '../../../../../utils/history';
import { showNotification } from '../../../../../utils/notification';
import SearchBoxCustom from '../../../components/SearchBoxCustom/SearchBoxCustom';
import styles from './create-or-edit.module.scss';
import moment from 'moment';
import CreateOrEditPositionCategoryModal from './components/CreateOrEditPositionCategoryModal';
import { ModelTC } from '../../../../../components';
import { v4 as uuidv4 } from 'uuid';
import { omit } from 'lodash';
import { meetingApi } from '../../../../../services/tcMeeting';
import CreateOrEditPositionInsightsModal from './components/CreateOrEditPositionInsightsModal';

const { Option } = Select;

const StatusCriticality = styled.div`
  padding: 4px 8px;
  width: fit-content;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.25px;
  text-align: center;
  ${(props) => {
    switch (props.status) {
      case 'Active':
        return css`
          background-color: #e1f2fe;
          color: #00488f;
        `;
      default:
        return css`
          background-color: #ebebebeb;
          color: #3d3d3d;
        `;
    }
  }}
`;
const infinityDate = '4712-12-30T17:00:00.000Z';

const initEmptyValue = {
  positionLabel: undefined,
  includedInRatio: undefined,
  business: undefined,
  role: undefined,
};
const includedInRatioOptions = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
];
async function getAllPosition({ keyword, roleActive }) {
  const result = (await adminApi.searchCriticalPositions({ keyword, _page: 1, _limit: 1, roleActive })).data?.result?.data[0];
  return result;
}
async function getAllOptions() {
  const result = await adminApi.getOptionsCriticalPositions();
  return result;
}
async function update(
  {
    positionCode,
    position_label,
    business,
    included_in_ratio,
    role,
    manual,
    status,
    new_position_code,
    new_position_name,
    sg,
    jg,
    sensitive_position,
    hsecp,
    skg,
    job_family,
    sub_job_family,
    functions,
    position_status,
    position_criticality,
    position_insights,
    department,
    division,
    sector,
    opu,
    location,
  },
  roles,
) {
  const result = await adminApi.updateCriticalPosition(
    {
      positionCode,
      position_label,
      business,
      included_in_ratio,
      role,
      manual,
      status,
      new_position_code,
      new_position_name,
      sg,
      jg,
      sensitive_position,
      hsecp,
      skg,
      job_family,
      sub_job_family,
      functions,
      position_status,
      position_criticality,
      position_insights,
      department,
      division,
      sector,
      opu,
      location,
    },
    roles,
  );
  return result;
}
async function create(
  {
    position_code,
    position_name,
    position_label,
    included_in_ratio,
    business,
    role,
    manual,
    status,
    sg,
    jg,
    sensitive_position,
    hsecp,
    skg,
    job_family,
    sub_job_family,
    functions,
    position_status,
    position_criticality,
    position_insights,
    department,
    division,
    sector,
    opu,
    location,
  },
  roles,
) {
  const result = await adminApi.addNewCriticalPosition(
    {
      position_code,
      position_name,
      position_label,
      included_in_ratio,
      business,
      role,
      manual,
      status,
      sg,
      jg,
      sensitive_position,
      hsecp,
      skg,
      job_family,
      sub_job_family,
      functions,
      position_status,
      position_criticality,
      position_insights,
      department,
      division,
      sector,
      opu,
      location,
    },
    roles,
  );
  return result;
}

export default function CreateOrEdit({ mode = 'create' }) {
  const [form] = Form.useForm();
  const roleActive = useSelector((state) => state.user.roleActive);
  const dispatch = useDispatch();
  const { positionCode } = useParams();
  const [positionName, setPositionName] = useState('');
  const [searchTerm, setSearchTerm] = useState({
    type: '',
    value: '',
    showTerm: '',
  });
  const [searchList, setSearchList] = useState([]);
  const positionCodeWatch = Form.useWatch('positionCode', form);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceLoadPositionName = useCallback(debounce(getPositionName, 500), []);
  const [manualToggle, setManualToggle] = useState(0);
  const [status, setStatus] = useState('active');
  const [errorPositionCode, setErrorPositionCode] = useState(false);
  const [oldPosition, setOldPosition] = useState('');
  const [oldManual, setOldManual] = useState(0);
  const [loading, setLoading] = useState(true);
  const [jgList, setJgList] = useState([]);
  const [sgList, setSgList] = useState([]);
  const [requiredPositionCode, setRequiredPositionCode] = useState(false);
  const [requiredPositionName, setRequiredPositionName] = useState(false);
  const [isOpenPositionCategory, setIsOpenPositionCategory] = useState(false);
  const [isOpenPositionInsights, setIsOpenPositionInsights] = useState(false);
  const [dropdownOptions, setDropDownOptions] = useState({
    sensitivePositionList: [],
    hseCPList: [],
    skgList: [],
    jobFamilyList: [],
    subJobFamilyList: [],
    functionList: [],
    positionStatusList: [],
    businessOptions: [],
    roleOptions: [],
    positionLabelOptions: [],
    departmentOptions: [],
    divisionOptions: [],
    sectorOptions: [],
    opuOptions: [],
  });
  const [selectSearchValues, setSelectSearchValues] = useState({
    department: '',
    division: '',
    sector: '',
    opu: '',
    sg: '',
    jg: '',
  });
  const [positionCategoryList, setPositionCategoryList] = useState([]);
  const [positionCriticalityList, setPositionCriticalityList] = useState([]);
  const [positionCriticalityDetail, setPositionCriticalityDetail] = useState({});
  const [isDeletePositionCategory, setIsDeletePositionCategory] = useState(false);
  const [deletedIdPositionCategory, setDeletedIdPositionCategory] = useState('');
  const [positionInsightsList, setPositionInsightsList] = useState([]);
  const [positionInsightsDetail, setPositionInsightsDetail] = useState({});
  const [isDeletePositionInsights, setIsDeletePositionInsights] = useState(false);
  const [deletedIdPositionInsights, setDeletedIdPositionInsights] = useState('');

  const getOptionsDepartment = async () => {
    try {
      const response = await adminApi.getDepartmentDropdown();
      if (response && response.data.code === 200 && response.data.result) {
        const departmentOptions = response.data.result.map((item) => ({ label: item.name, value: item.name }));
        setDropDownOptions((prev) => ({ ...prev, departmentOptions: departmentOptions }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOptionsDivision = async () => {
    try {
      const response = await meetingApi.getDivisionDropdown();
      if (response && response.data.code === 200 && response.data.result) {
        const divisionOptions = response.data.result.map((item) => ({ label: item.name, value: item.name }));
        setDropDownOptions((prev) => ({ ...prev, divisionOptions: divisionOptions }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOptionsSector = async () => {
    try {
      const response = await meetingApi.getSectorDropdown();
      if (response && response.data.code === 200 && response.data.result) {
        const sectorOptions = response.data.result.map((item) => ({ label: item.name, value: item.name }));
        setDropDownOptions((prev) => ({ ...prev, sectorOptions: sectorOptions }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOptionsOpu = async () => {
    try {
      const response = await meetingApi.getOPUDropdown();
      if (response && response.data.code === 200 && response.data.result) {
        const opuOptions = response.data.result.map((item) => ({ label: item.name, value: item.name }));
        setDropDownOptions((prev) => ({ ...prev, opuOptions: opuOptions }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOptionsPositionCategory = async () => {
    try {
      const response = await adminApi.getOptionsPositionCategory({ roleActive });
      if (response && response.data.code === 200 && response.data.result) {
        setPositionCategoryList(mapDataDropdownOptions(response.data.result));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (manualToggle === 0) {
      return;
    }

    getOptionsDepartment();
    getOptionsDivision();
    getOptionsSector();
    getOptionsOpu();
  }, [manualToggle]);

  const handleSubmitPositionCategory = (data, editId) => {
    const positionCategory = {
      position_category: data.positionCategory,
      criticality_status: data.criticalityStatus,
      end_date_toggle: data.noEndDate,
      start_date: data.startDate?.format(),
      end_date: data.noEndDate ? null : data.endDate?.format(),
    };

    if (editId) {
      const updatedData = positionCriticalityList.map((item) =>
        item.id === editId
          ? {
              ...positionCategory,
              id: item.id,
            }
          : item,
      );
      setPositionCriticalityList(updatedData);
    } else {
      setPositionCriticalityList([
        ...positionCriticalityList,
        {
          ...positionCategory,
          id: uuidv4(),
        },
      ]);
    }
  };

  const handleSubmitPositionInsights = (data, editId) => {
    const positionInsights = {
      report_to: data.report_to,
      current_incumbent: data.current_incumbent,
      end_date_toggle: data.noEndDate,
      start_date: data.startDate?.format(),
      end_date: data.noEndDate ? null : data.endDate?.format(),
    };

    if (editId) {
      const updatedData = positionInsightsList.map((item) =>
        item.id === editId
          ? {
              ...positionInsights,
              id: item.id,
            }
          : item,
      );
      setPositionInsightsList(updatedData);
    } else {
      setPositionInsightsList([
        ...positionInsightsList,
        {
          ...positionInsights,
          id: uuidv4(),
        },
      ]);
    }
  };

  const COLUMNS = [
    {
      title: 'Position Category',
      width: '25%',
      dataIndex: 'position_category',
      render: (value) => <span className={styles.text}>{value || ''}</span>,
    },
    {
      title: 'Start Date',
      width: '25%',
      dataIndex: 'start_date',
      render: (value) => <span className={styles.text}>{value ? moment(value).format('DD MMMM YYYY') : ''}</span>,
    },
    {
      title: 'End Date',
      dataIndex: 'end_date',
      width: '25%',
      render: (value, record) => (
        <span className={styles.text}>
          {value ? moment(value).format('DD MMMM YYYY') : record.end_date_toggle ? moment(infinityDate).format('DD MMMM YYYY') : ''}
        </span>
      ),
    },
    {
      title: 'Criticality Status',
      width: '20%',
      dataIndex: 'criticality_status',
      render: (value) => (value ? <StatusCriticality status={value}>{value}</StatusCriticality> : <span>{''}</span>),
    },
    {
      title: '',
      width: '5%',
      dataIndex: 'id',
      render: (_, record) => (
        <div className={styles.dropDownItem}>
          <Dropdown
            menu={{
              items: [
                {
                  label: <div className={styles.editDeleteItem}>Edit</div>,
                  key: '0',
                  onClick: () => {
                    setPositionCriticalityDetail(record);
                    setIsOpenPositionCategory(true);
                  },
                },
                {
                  label: <div className={styles.editDeleteItem}>Delete</div>,
                  key: '1',
                  onClick: () => {
                    setDeletedIdPositionCategory(record.id);
                    setIsDeletePositionCategory(true);
                  },
                },
              ],
            }}
            trigger={['click']}
            style={{ minWidth: 50 }}
            placement="bottomRight"
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Space style={{ cursor: 'pointer' }}>
              <img src={edit_delete} alt="dot" />
            </Space>
          </Dropdown>
        </div>
      ),
    },
  ];

  const POSITION_INSIGHTS_COLUMNS = [
    {
      title: 'Report To',
      width: '25%',
      dataIndex: 'report_to',
      render: (value) => <span className={styles.text}>{value || ''}</span>,
    },
    {
      title: 'Current Incumbent',
      width: '25%',
      dataIndex: 'current_incumbent',
      render: (value) => <span className={styles.text}>{value || ''}</span>,
    },
    {
      title: 'Start Date',
      width: '25%',
      dataIndex: 'start_date',
      render: (value) => <span className={styles.text}>{value ? moment(value).format('DD MMMM YYYY') : ''}</span>,
    },
    {
      title: 'End Date',
      dataIndex: 'end_date',
      width: '20%',
      render: (value, record) => (
        <span className={styles.text}>
          {value ? moment(value).format('DD MMMM YYYY') : record.end_date_toggle ? moment(infinityDate).format('DD MMMM YYYY') : ''}
        </span>
      ),
    },
    {
      title: '',
      width: '5%',
      dataIndex: 'id',
      render: (_, record) => (
        <div className={styles.dropDownItem}>
          <Dropdown
            menu={{
              items: [
                {
                  label: <div className={styles.editDeleteItem}>Edit</div>,
                  key: '0',
                  onClick: () => {
                    setPositionInsightsDetail(record);
                    setIsOpenPositionInsights(true);
                  },
                },
                {
                  label: <div className={styles.editDeleteItem}>Delete</div>,
                  key: '1',
                  onClick: () => {
                    setDeletedIdPositionInsights(record.id);
                    setIsDeletePositionInsights(true);
                  },
                },
              ],
            }}
            trigger={['click']}
            style={{ minWidth: 50 }}
            placement="bottomRight"
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Space style={{ cursor: 'pointer' }}>
              <img src={edit_delete} alt="dot" />
            </Space>
          </Dropdown>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (mode !== 'create' || !positionCodeWatch) return;
    const roles = {
      role: roleActive,
    };
    debounceLoadPositionName({ positionCodeWatch, roles });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, positionCodeWatch, roleActive]);

  useEffect(() => {
    setLoading(true);
    getOptionsPositionCategory();
    getAllOptions()
      .then((res) => {
        const positionLabels = mapDataDropdownOptions(res?.data?.result?.position_labels);
        const businesses = mapDataDropdownOptions(res?.data?.result?.businesses);
        const roles = mapDataDropdownOptions(res?.data?.result?.roles);
        const sensitivePositions = mapDataDropdownOptions(res?.data?.result?.sensitive_position);
        const hseCPs = mapDataDropdownOptions(res?.data?.result?.hsecp);
        const skgs = mapDataDropdownOptions(res?.data?.result?.skg);
        const jobFamilys = mapDataDropdownOptions(res?.data?.result?.job_family);
        const subJobFamilys = mapDataDropdownOptions(res?.data?.result?.sub_job_family);
        const functions = mapDataDropdownOptions(res?.data?.result?.function);
        const positionStatus = mapDataDropdownOptions(res?.data?.result?.position_status);

        setDropDownOptions({
          sensitivePositionList: sensitivePositions,
          hseCPList: hseCPs,
          skgList: skgs,
          jobFamilyList: jobFamilys,
          subJobFamilyList: subJobFamilys,
          functionList: functions,
          positionStatusList: positionStatus,
          businessOptions: businesses,
          roleOptions: roles,
          positionLabelOptions: positionLabels,
          departmentOptions: [],
          divisionOptions: [],
          sectorOptions: [],
          opuOptions: [],
        });
      })
      .catch((_err) => {
        showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
      });

    (async function getListByGrade() {
      try {
        const jgList = await adminApi.getListByGrade({ type: 'jg' });
        setJgList(
          get(jgList, 'data.result').map((item) => {
            return {
              value: item,
              label: item,
            };
          }),
        );
        const sgList = await adminApi.getListByGrade({ type: 'sg' });
        setSgList(
          get(sgList, 'data.result').map((item) => {
            return {
              value: item,
              label: item,
            };
          }),
        );
      } catch (error) {
        showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
      }
    })();
    setLoading(false);
  }, []);

  useEffect(() => {
    if (searchTerm.type === 'submit') {
      setRequiredPositionCode(false);
      setPositionName(searchTerm.value.position_name);
      form.setFieldsValue({
        sensitivePosition: searchTerm.value.sensitive_position || null,
        hseCP: searchTerm.value.hsecp || null,
        skg: searchTerm.value.skg_text || null,
        jobFamily: searchTerm.value.job_family || null,
        subJobFamily: searchTerm.value.sub_job_family || null,
        function: searchTerm.value.job_function || null,
        positionStatus: searchTerm.value.position_status || null,
      });
    }
    if (searchTerm.type === 'search') {
      setPositionName('');
      form.setFieldsValue({
        ...form.getFieldsValue(),
        sensitivePosition: null,
        hseCP: null,
        skg: null,
        jobFamily: null,
        subJobFamily: null,
        function: null,
        positionStatus: null,
      });
    }
  }, [searchTerm.type, searchTerm.value.position_code, searchTerm.value.position_name]);

  useEffect(() => {
    if (mode !== 'edit' || !positionCode) return;
    setLoading(true);
    getAllPosition({ keyword: positionCode, roleActive })
      .then((res) => {
        const { business, included_in_ratio, position_code, position_label, position_name, role, status, manual, sg, jg } = res;
        setOldPosition(position_code);
        setSearchTerm({ showTerm: position_code, value: { position_code, position_name } });
        setPositionName(position_name);
        setStatus(status);
        setManualToggle(manual);
        setOldManual(manual);
        setPositionCriticalityList(res?.position_criticality || []);
        setPositionInsightsList(res?.position_insights || []);
        form.setFieldsValue({
          positionLabel: position_label || undefined,
          includedInRatio: included_in_ratio || undefined,
          business: business || undefined,
          role: role || undefined,
          sensitivePosition: res?.sensitive_position || null,
          hseCP: res?.hsecp || null,
          skg: res?.skg || null,
          jobFamily: res?.job_family || null,
          subJobFamily: res?.sub_job_family || null,
          function: res?.functions || null,
          positionStatus: res?.position_status || null,
          department: res?.department || null,
          division: res?.division || null,
          sector: res?.sector || null,
          opu: res?.opu || null,
          location: res?.location || null,
          sg: sg || null,
          jg: jg || null,
        });
      })
      .catch((_err) => {
        showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, positionCode]);

  async function getPositionName({ positionCodeWatch, roles }) {
    try {
      const result = await adminApi.getPositionNameByPositionCode({
        positionCode: positionCodeWatch,
        roles,
      });
      const position_name = result?.data?.result?.position_name;
      form.setFieldValue('positionName', position_name);
      form.validateFields(['positionName']);
    } catch (error) {
      form.setFieldValue('positionName', undefined);
    }
  }
  const onSubmit = () => {
    if (!searchTerm?.value || searchTerm?.type === 'search') {
      dispatch(
        pushMessage({
          type: MESSAGE_TYPES.ERROR,
          message: 'There are items that require your attention. Please fill in the required field(s)',
        }),
      );
      form.validateFields();
      setRequiredPositionCode(true);
      setRequiredPositionName(true);
      return;
    }

    const positionCode = parseInt(searchTerm?.value?.position_code?.trim());

    form
      .validateFields()
      .then((_res) => {
        const isValid = checkIntegerNumber(positionCode);
        if (!isValid) {
          setErrorPositionCode(true);
          return;
        }
        setErrorPositionCode(false);
        form.submit();
      })
      .catch((_err) => {
        showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
        dispatch(
          pushMessage({
            type: MESSAGE_TYPES.ERROR,
            message: 'There are items that require your attention. Please fill in the required field(s)',
          }),
        );
      });
  };

  const onFinish = (values) => {
    const roles = {
      role: roleActive,
    };
    const positionCode = searchTerm.value.position_code.trim();

    const data = {
      position_label: values.positionLabel,
      included_in_ratio: values.includedInRatio,
      business: values.business,
      role: values.role,
      manual: manualToggle,
      status: status,
      sg: values.sg || null,
      jg: values.jg || null,
      sensitive_position: values.sensitivePosition || null,
      hsecp: values.hseCP || null,
      skg: values.skg || null,
      job_family: values.jobFamily || null,
      sub_job_family: values.subJobFamily || null,
      functions: values.function || null,
      position_status: values.positionStatus || null,
      position_criticality: positionCriticalityList.map((item) => omit(item, ['id'])),
      position_insights: positionInsightsList.map((item) => omit(item, ['id'])),
      department: values.department || null,
      division: values.division || null,
      sector: values.sector || null,
      opu: values.opu || null,
      location: values.location || null,
    };
    if (mode === 'edit') {
      data.positionCode = oldPosition;
      data.new_position_code = positionCode;
      data.new_position_name = positionName.trim();
      update(data, roles)
        .then((_res) => {
          history.push('/admin/sp-management/managing-critical-position');
          dispatch(
            pushMessage({
              type: MESSAGE_TYPES.SUCCESS,
              message: `${positionName} ${positionCode} successfully Edited`,
            }),
          );
        })
        .catch((err) => {
          showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
          const error = get(err, 'response.data.errors');
          dispatch(
            pushMessage({
              type: MESSAGE_TYPES.ERROR,
              message: error,
            }),
          );
        });
      return;
    }

    data.position_code = positionCode;
    data.position_name = positionName.trim();

    create(data, roles)
      .then((_res) => {
        history.push('/admin/sp-management/managing-critical-position');
        dispatch(
          pushMessage({
            type: MESSAGE_TYPES.SUCCESS,
            message: `${positionName} (${positionCode}) successfully added`,
          }),
        );
      })
      .catch((err) => {
        dispatch(
          pushMessage({
            type: MESSAGE_TYPES.ERROR,
            message: err?.response?.data?.errors,
          }),
        );
      });
  };

  const onCancel = () => {
    history.push('/admin/sp-management/managing-critical-position');
  };

  const changeInputPositionCode = (e) => {
    const val = e.target.value;
    setSearchTerm((prev) => {
      return {
        ...prev,
        value: {
          position_code: val,
        },
      };
    });
  };

  return (
    <Spin spinning={loading}>
      <h3 className={styles.mainTitle}>
        {mode === 'create' ? 'Add New Critical Position' : 'Edit Critical Position'}
        <span className={styles.subText} data-testid="noteTitle">
          Succession Planning Management
        </span>
      </h3>
      <div className={styles.main}>
        <div>
          <Row justify="space-between">
            <p className={styles.title}>{mode === 'create' ? 'Add New Details' : 'Details'}</p>
            <Col>
              <Switch
                onChange={(checked) => {
                  setManualToggle(checked ? 1 : 0);
                  setPositionName('');
                  setSearchTerm({
                    type: '',
                    value: '',
                    showTerm: '',
                  });
                  setRequiredPositionCode(false);
                  setRequiredPositionName(false);
                  setPositionCriticalityList([]);
                  setPositionInsightsList([]);
                  form.resetFields();
                }}
                checked={manualToggle}
                style={{ backgroundColor: `${manualToggle ? '#009089' : ''}` }}
                disabled={mode === 'edit'}
              />
              <span style={{ marginLeft: '10px' }}>Manual</span>
            </Col>
          </Row>
        </div>
        <div className="mb-3">
          <Form onFinish={onFinish} form={form} initialValues={mode === 'create' ? initEmptyValue : { positionCode }} autoComplete="off">
            <Row gutter={16}>
              <Col span={8} className={styles.customize}>
                <BasicLabel required style={{ margin: '5px 0' }}>
                  Position Code
                </BasicLabel>
                {!manualToggle && (
                  <SearchBoxCustom
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    searchList={searchList}
                    setSearchList={setSearchList}
                    fieldName={'position_code_critical'}
                    searchPlaceholder={'Search Position Code'}
                    isReadOnly={!oldManual && mode === 'edit'}
                    isShowRequired={requiredPositionCode}
                  />
                )}
                {Boolean(manualToggle) && (
                  <BasicInput
                    height={44}
                    plhColor="#bfbfbf"
                    value={searchTerm.value.position_code || ''}
                    onChange={changeInputPositionCode}
                    error={(requiredPositionCode && !searchTerm?.value?.position_code) || (searchTerm?.value?.position_code && errorPositionCode)}
                    placeholder="Position Code"
                    disabled={!manualToggle}
                  />
                )}
                {searchTerm?.value?.position_code && errorPositionCode && (
                  <span style={{ color: '#f85032', fontSize: '12px' }}>Position Code input is invalid. Please enter in numbering format</span>
                )}
              </Col>
              <Col span={8} className={`${styles.customize} mb-3`}>
                <BasicLabel required={Boolean(manualToggle)} style={{ margin: '5px 0' }}>
                  Position Name
                </BasicLabel>
                <BasicInput
                  height={44}
                  plhColor="#bfbfbf"
                  value={positionName || ''}
                  onChange={(e) => {
                    const val = e.target.value;
                    setPositionName(val);
                  }}
                  error={requiredPositionName && !positionName}
                  placeholder="Position Name"
                  disabled={!manualToggle}
                />
              </Col>
              <Col span={8} className={styles.customize}>
                <BasicLabel style={{ margin: '5px 0' }}>Status</BasicLabel>
                <Select
                  data-testid="status-option"
                  placeholder="Select"
                  suffixIcon={<img alt="" src={dropdown_icon} />}
                  style={{ width: '100%' }}
                  value={status}
                  onChange={(e) => setStatus(e)}
                >
                  <Option key="active" value="active">
                    Active
                  </Option>
                  <Option key="in-active" value="in-active">
                    InActive
                  </Option>
                </Select>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8} className={styles.customize}>
                <Form.Item rules={[{ required: true, message: '' }]} name="positionLabel" labelCol={{ span: 24 }} label="Position Label">
                  <Select data-testid="position-label-option" placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />}>
                    {dropdownOptions.positionLabelOptions.map((item) => (
                      <Option key={item.value} value={item.value}>
                        <span data-testid={item.label}>{item.label}</span>{' '}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} className={styles.customize}>
                <Form.Item name="includedInRatio" labelCol={{ span: 24 }} label="Included in Ratio" rules={[{ required: true, message: '' }]}>
                  <Select data-testid="included-in-ratio-option" placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />}>
                    {includedInRatioOptions.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} className={styles.customize}>
                <Form.Item name="business" labelCol={{ span: 24 }} label="Business" rules={[{ required: true, message: '' }]}>
                  <Select data-testid="business-option" placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />}>
                    {dropdownOptions.businessOptions.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8} className={styles.customize}>
                <Form.Item name="role" labelCol={{ span: 24 }} label="Role" rules={[{ required: true, message: '' }]}>
                  <Select data-testid="role-option" placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />}>
                    {dropdownOptions.roleOptions.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} className={styles.customize}>
                <Form.Item name="sensitivePosition" labelCol={{ span: 24 }} label="Sensitive Position">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.sensitivePositionList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} className={styles.customize}>
                <Form.Item name="hseCP" labelCol={{ span: 24 }} label="HSE CP">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.hseCPList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6} className={styles.customize}>
                <Form.Item name="skg" labelCol={{ span: 24 }} label="SKG">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.skgList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6} className={styles.customize}>
                <Form.Item name="jobFamily" labelCol={{ span: 24 }} label="Job Family">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.jobFamilyList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6} className={styles.customize}>
                <Form.Item name="subJobFamily" labelCol={{ span: 24 }} label="Sub-Job Family">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.subJobFamilyList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6} className={styles.customize}>
                <Form.Item name="function" labelCol={{ span: 24 }} label="Function">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.functionList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={6} className={styles.customize}>
                <Form.Item name="positionStatus" labelCol={{ span: 24 }} label="Position Status">
                  <Select placeholder="Select" suffixIcon={<img alt="" src={dropdown_icon} />} disabled={!manualToggle}>
                    {dropdownOptions.positionStatusList.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {Boolean(manualToggle) && (
                <Col span={6} className={styles.customize}>
                  <Form.Item name="sg" labelCol={{ span: 24 }} label="SG">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select or type"
                      suffixIcon={
                        <img className={form.getFieldValue('sg') ? styles['custom-dropdown-select-icon'] : ''} alt="" src={dropdown_icon} />
                      }
                      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(val) => setSelectSearchValues((prev) => ({ ...prev, sg: val }))}
                      onSelect={() => setSelectSearchValues((prev) => ({ ...prev, sg: '' }))}
                      onClear={() => setSelectSearchValues((prev) => ({ ...prev, sg: '' }))}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          {selectSearchValues.sg && (
                            <div
                              style={{
                                padding: '5px 12px',
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                                color: '#00a19c',
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                form.setFieldValue('sg', selectSearchValues.sg);
                                setSelectSearchValues((prev) => ({ ...prev, sg: '' }));
                              }}
                            >
                              + Use &quot;{selectSearchValues.sg}&quot;
                            </div>
                          )}
                        </>
                      )}
                      className={styles['custom-dropdown-select']}
                    >
                      {sgList.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              {Boolean(manualToggle) && (
                <Col span={6} className={styles.customize}>
                  <Form.Item name="jg" labelCol={{ span: 24 }} label="JG">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select or type"
                      suffixIcon={
                        <img className={form.getFieldValue('jg') ? styles['custom-dropdown-select-icon'] : ''} alt="" src={dropdown_icon} />
                      }
                      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(val) => setSelectSearchValues((prev) => ({ ...prev, jg: val }))}
                      onSelect={() => setSelectSearchValues((prev) => ({ ...prev, jg: '' }))}
                      onClear={() => setSelectSearchValues((prev) => ({ ...prev, jg: '' }))}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          {selectSearchValues.jg && (
                            <div
                              style={{
                                padding: '5px 12px',
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                                color: '#00a19c',
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                form.setFieldValue('jg', selectSearchValues.jg);
                                setSelectSearchValues((prev) => ({ ...prev, jg: '' }));
                              }}
                            >
                              + Use &quot;{selectSearchValues.jg}&quot;
                            </div>
                          )}
                        </>
                      )}
                      className={styles['custom-dropdown-select']}
                    >
                      {jgList.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            </Row>
            {Boolean(manualToggle) && (
              <Row gutter={16}>
                <Col span={6} className={styles.customize}>
                  <Form.Item name="department" labelCol={{ span: 24 }} label="Department">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select or type"
                      suffixIcon={
                        <img className={form.getFieldValue('department') ? styles['custom-dropdown-select-icon'] : ''} alt="" src={dropdown_icon} />
                      }
                      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(val) => setSelectSearchValues((prev) => ({ ...prev, department: val }))}
                      onSelect={() => setSelectSearchValues((prev) => ({ ...prev, department: '' }))}
                      onClear={() => setSelectSearchValues((prev) => ({ ...prev, department: '' }))}
                      className={styles['custom-dropdown-select']}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          {selectSearchValues.department && (
                            <div
                              style={{
                                padding: '5px 12px',
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                                color: '#00a19c',
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                form.setFieldValue('department', selectSearchValues.department);
                                setSelectSearchValues((prev) => ({ ...prev, department: '' }));
                              }}
                            >
                              + Use &quot;{selectSearchValues.department}&quot;
                            </div>
                          )}
                        </>
                      )}
                    >
                      {dropdownOptions.departmentOptions.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6} className={styles.customize}>
                  <Form.Item name="division" labelCol={{ span: 24 }} label="Division">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select or type"
                      suffixIcon={
                        <img className={form.getFieldValue('division') ? styles['custom-dropdown-select-icon'] : ''} alt="" src={dropdown_icon} />
                      }
                      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(val) => setSelectSearchValues((prev) => ({ ...prev, division: val }))}
                      onSelect={() => setSelectSearchValues((prev) => ({ ...prev, division: '' }))}
                      onClear={() => setSelectSearchValues((prev) => ({ ...prev, division: '' }))}
                      className={styles['custom-dropdown-select']}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          {selectSearchValues.division && (
                            <div
                              style={{
                                padding: '5px 12px',
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                                color: '#00a19c',
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                form.setFieldValue('division', selectSearchValues.division);
                                setSelectSearchValues((prev) => ({ ...prev, division: '' }));
                              }}
                            >
                              + Use &quot;{selectSearchValues.division}&quot;
                            </div>
                          )}
                        </>
                      )}
                    >
                      {dropdownOptions.divisionOptions.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6} className={styles.customize}>
                  <Form.Item name="sector" labelCol={{ span: 24 }} label="Sector">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select or type"
                      suffixIcon={
                        <img className={form.getFieldValue('sector') ? styles['custom-dropdown-select-icon'] : ''} alt="" src={dropdown_icon} />
                      }
                      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(val) => setSelectSearchValues((prev) => ({ ...prev, sector: val }))}
                      onSelect={() => setSelectSearchValues((prev) => ({ ...prev, sector: '' }))}
                      onClear={() => setSelectSearchValues((prev) => ({ ...prev, sector: '' }))}
                      className={styles['custom-dropdown-select']}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          {selectSearchValues.sector && (
                            <div
                              style={{
                                padding: '5px 12px',
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                                color: '#00a19c',
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                form.setFieldValue('sector', selectSearchValues.sector);
                                setSelectSearchValues((prev) => ({ ...prev, sector: '' }));
                              }}
                            >
                              + Use &quot;{selectSearchValues.sector}&quot;
                            </div>
                          )}
                        </>
                      )}
                    >
                      {dropdownOptions.sectorOptions.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6} className={styles.customize}>
                  <Form.Item name="opu" labelCol={{ span: 24 }} label="OPU">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Select or type"
                      suffixIcon={
                        <img className={form.getFieldValue('opu') ? styles['custom-dropdown-select-icon'] : ''} alt="" src={dropdown_icon} />
                      }
                      filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                      onSearch={(val) => setSelectSearchValues((prev) => ({ ...prev, opu: val }))}
                      onSelect={() => setSelectSearchValues((prev) => ({ ...prev, opu: '' }))}
                      onClear={() => setSelectSearchValues((prev) => ({ ...prev, opu: '' }))}
                      className={styles['custom-dropdown-select']}
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          {selectSearchValues.opu && (
                            <div
                              style={{
                                padding: '5px 12px',
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                                color: '#00a19c',
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                form.setFieldValue('opu', selectSearchValues.opu);
                                setSelectSearchValues((prev) => ({ ...prev, opu: '' }));
                              }}
                            >
                              + Use &quot;{selectSearchValues.opu}&quot;
                            </div>
                          )}
                        </>
                      )}
                    >
                      {dropdownOptions.opuOptions.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {Boolean(manualToggle) && (
              <Row gutter={16}>
                <Col span={8} className={styles.customize}>
                  <Form.Item name="location" labelCol={{ span: 24 }} label="Location">
                    <BasicInput height={44} plhColor="#bfbfbf" placeholder="Location" />
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Form>
        </div>
        <div className="mb-3">
          <Row justify="space-between">
            <p className={styles.title}>Position Criticality</p>
            <BasicButton
              mode="teal"
              onClick={() => {
                setIsOpenPositionCategory(true);
              }}
            >
              Add New Category
            </BasicButton>
          </Row>
          <BasicTable
            rowKey="id"
            styles={{
              headerColor: '#8896A7',
              headerWeight: 700,
              borderRadius: 6,
            }}
            dataSource={positionCriticalityList}
            columns={COLUMNS}
            pagination={false}
          />
          {isOpenPositionCategory && (
            <CreateOrEditPositionCategoryModal
              open={isOpenPositionCategory}
              setOpen={setIsOpenPositionCategory}
              positionCategoryList={positionCategoryList}
              handleSubmitPositionCategory={handleSubmitPositionCategory}
              positionCriticalityDetail={positionCriticalityDetail}
              setPositionCriticalityDetail={setPositionCriticalityDetail}
            />
          )}
          <ModelTC
            info={{
              type: 'deletePositionCategory',
              visible: isDeletePositionCategory,
              setVisible: setIsDeletePositionCategory,
              onClose: () => setIsDeletePositionCategory(false),
              handleSubmit: () => {
                const positionCriticalityListFilter = positionCriticalityList.filter((item) => item.id !== deletedIdPositionCategory);
                setPositionCriticalityList(positionCriticalityListFilter);
                setIsDeletePositionCategory(false);
              },
            }}
          />
        </div>
        <div>
          <Row justify="space-between">
            <p className={styles.title}>Position Insights</p>
            <BasicButton
              mode="teal"
              onClick={() => {
                setIsOpenPositionInsights(true);
              }}
            >
              Add New Insights
            </BasicButton>
          </Row>
          <BasicTable
            rowKey="id"
            styles={{
              headerColor: '#8896A7',
              headerWeight: 700,
              borderRadius: 6,
            }}
            dataSource={positionInsightsList}
            columns={POSITION_INSIGHTS_COLUMNS}
            pagination={false}
          />
          {isOpenPositionInsights && (
            <CreateOrEditPositionInsightsModal
              open={isOpenPositionInsights}
              setOpen={setIsOpenPositionInsights}
              positionInsightsList={positionInsightsList}
              handleSubmitPositionInsights={handleSubmitPositionInsights}
              positionInsightsDetail={positionInsightsDetail}
              setPositionInsightsDetail={setPositionInsightsDetail}
            />
          )}
          <ModelTC
            info={{
              type: 'deletePositionInsights',
              visible: isDeletePositionInsights,
              setVisible: setIsDeletePositionInsights,
              onClose: () => setIsDeletePositionInsights(false),
              handleSubmit: () => {
                const positionInsightsListFilter = positionInsightsList.filter((item) => item.id !== deletedIdPositionInsights);
                setPositionInsightsList(positionInsightsListFilter);
                setIsDeletePositionInsights(false);
              },
            }}
          />
        </div>
      </div>
      <div className={styles.grBtn}>
        <Row gutter={8}>
          <Col>
            <Button data-testid="cancel-btn" onClick={onCancel} className={styles.cancel}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button data-testid="submit-btn" onClick={onSubmit} htmlType="submit" className={styles.add}>
              {mode === 'create' ? 'Add' : 'Save'}
            </Button>
          </Col>
        </Row>
      </div>
    </Spin>
  );
}
